<template>
    <form v-if="hasAccess" @submit.prevent="save" class="clearfix pb-4">
        <top-nav-bar :goto="backLink"></top-nav-bar>

        <div class="max-w-sm mx-auto pt-2 px-4" v-if="!loading">
            <h4 class="text-center mb-4 break-words" v-text="`Edit Document - ${document.type}`"></h4>

            <form-group name="document" label="Document" :required="true"
                        help="Accepted file-types: PDF"
                        v-if="document.crew_portal_visible && document.crew_portal_editable">
                <upload-file-button @change="processFile"/>
            </form-group>

            <form-group name="expire_date" label="Expire Date" :required="true"
                        v-if="document.must_expire && document.crew_portal_visible && document.crew_portal_editable">
                <datepicker
                        placeholder="Select expire date"
                        id="expire_date"
                        name="expire_date"
                        :min-date="minStartDate"
                        :max-date="maxStartDate"
                        v-model="expire_date"
                />
            </form-group>

            <div class="block md:inline-flex md:float-right">
                <button class="btn btn--colored__green w-full" type="submit"
                        v-if="document.crew_portal_visible && document.crew_portal_editable">
                    <i class="fal fa-check"></i>
                    Save
                </button>
            </div>
        </div>
        <div v-else class="h-full flex items-center justify-center">
            <div class="py-5 spinner-blue"></div>
        </div>
    </form>
</template>

<script>
    import moment from 'moment';
    import UploadFileButton from "../components/UploadFileButton";
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [CanAccessView],
        components: {UploadFileButton},
        data() {
            return {
                document: {
                    document: '',
                    crew_portal_visible: false,
                    crew_portal_editable: false,
                },
                expire_date: null,
                saving: false,
                loading: true,
            }
        },

        computed: {
            minStartDate() {
                return moment().format('YYYY-MM-DD')
            },
            maxStartDate() {
                return moment().add(100, 'years').format('YYYY-MM-DD')
            },
            backLink() {
                if (this.$route.params.type) {
                    return '/documents/mandatory/' + this.$route.params.type;
                } else {
                    return `/documents/${this.$route.params.document}`;
                }
            }
        },

        mounted() {
            if (this.$route.params.type) {
                this.$api('hr').get(`employee/documents/mandatory/${this.$route.params.type}`)
                    .then(({data}) => {
                        this.loading = false;
                        this.document = data.data.document
                    })
                    .catch(() => {
                        this.$router.replace('/documents');
                    });
            } else {
                this.$api('hr').get(`employee/documents/${this.$route.params.document}`)
                    .then(({data}) => {
                        this.loading = false;
                        this.document = data.data.document
                        this.expire_date = this.document.expire_date
                    })
                    .catch(() => {
                        this.$router.replace('/documents');
                    });
            }
        },

        methods: {
            processFile(event) {
                let files = event.target.files;

                if (files.length) {
                    this.document.document = files[0];
                }
            },

            save(e) {
                this.loading = true;
                this.$store.commit('setErrors', null);
                this.saving = true;
                let url;

                let data = new FormData();
                data.append('document', this.document.document);

                if (this.expire_date) {
                    data.append('expire_date', this.expire_date)
                }

                if (this.$route.params.type) {
                    url = `employee/documents/mandatory/${this.$route.params.type}`;
                } else {
                    url = `employee/documents/${this.$route.params.document}`;
                }

                this.$api('hr').post(url, data)
                    .then(response => {
                        this.saving = false;
                        this.$router.push('/documents');
                        this.$noty.success('Document uploaded.');
                        this.$store.dispatch('fetchUnreadNotifications');
                        this.loading = false;
                    })
                    .catch(({response}) => {
                        this.loading = false;
                        this.$store.commit('setErrors', response.data);
                    })
            },

            cancel() {
                if (this.$route.params.type) {
                    this.$router.push('/documents/mandatory/' + this.$route.params.type);
                } else {
                    this.$router.push(`/documents/${this.$route.params.document}`)
                }
            },
        }

    }
</script>
